(function () {
  const slider = document.querySelector('.prouductnewslider');
  const slides = slider.querySelectorAll('.productslide');

  const thumbList = document.querySelector('.thumbnaillist');
  const thumbs = thumbList.querySelectorAll('.thumbslider__slide');

  if (!slides.length || !thumbs.length) return;

  let currentIndex = 0;
  const MAX_VISIBLE_THUMBS = 4;

  const prevBtn = document.createElement('button');
  const nextBtn = document.createElement('button');

  prevBtn.className = 'slider-nav prev';
  nextBtn.className = 'slider-nav next';

  prevBtn.innerHTML = '‹';
  nextBtn.innerHTML = '›';

  slider.appendChild(prevBtn);
  slider.appendChild(nextBtn);

  function init() {
    slides.forEach((slide, i) => {
      slide.style.display = i === 0 ? 'block' : 'none';
    });

    updateThumbnails();
  }

  function goToSlide(index) {
    if (index < 0 || index >= slides.length) return;

    slides[currentIndex].style.display = 'none';
    slides[index].style.display = 'block';

    currentIndex = index;

    updateActiveThumb();
  }

  function next() {
    const nextIndex = (currentIndex + 1) % slides.length;
    goToSlide(nextIndex);
  }

  function prev() {
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
    goToSlide(prevIndex);
  }

  nextBtn.addEventListener('click', next);
  prevBtn.addEventListener('click', prev);

  function updateActiveThumb() {
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === currentIndex);
    });
  }

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      goToSlide(index);
    });
  });

 function updateThumbnails() {
  const total = thumbs.length;


  thumbs.forEach((thumb) => {
    thumb.style.display = 'block';

    const oldOverlay = thumb.querySelector('.thumb-more');
    if (oldOverlay) oldOverlay.remove();
  });

  if (total > MAX_VISIBLE_THUMBS) {
    thumbs.forEach((thumb, i) => {
      if (i >= MAX_VISIBLE_THUMBS) {
        thumb.style.display = 'none';
      }
    });

    const remaining = total - MAX_VISIBLE_THUMBS;

    const targetThumb = thumbs[MAX_VISIBLE_THUMBS - 1]; // 4th thumb

    const overlay = document.createElement('div');
    overlay.className = 'thumb-more';
    overlay.innerHTML = `+${remaining}`;

    // click → reveal all
    overlay.addEventListener('click', (e) => {
      e.stopPropagation(); // prevent triggering thumb click

      thumbs.forEach(t => (t.style.display = 'block'));
      overlay.remove();
    });

    targetThumb.appendChild(overlay);
  }

  updateActiveThumb();
}

  init();
})();